export abstract class DataLayerModel {
	public event: string | undefined;
	protected constructor(event: string | undefined) {
		this.event = event;
	}
}